import { provideConfig } from '@spartacus/core'
import { NgModule } from '@angular/core'
import { FsComponentConverter } from 'fs-spartacus-common'
import { TEASER_BIG_CONVERTER_TOKEN, TeaserBigConverter } from './teaser-big.component.converter'

@NgModule({
  providers: [
    provideConfig({
      featureModules: {
        teaserBigFeature: {
          module: () => import('./teaser-big.module').then((m) => m.TeaserBigModule),
          cmsComponents: ['teaser_big'],
        },
      }
    }),
    {
      provide: TEASER_BIG_CONVERTER_TOKEN,
      useClass: TeaserBigConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        teaser_big: TEASER_BIG_CONVERTER_TOKEN
      },
      multi: true
    }
  ]
})
export class TeaserBigFeatureModule {}
